(function () {
  let bootPromise = null;

  function whenUsfReady(callback, attempts) {
    if (window.usf?.utils?.installSearchInput) {
      callback();
      return;
    }
    if ((attempts || 0) >= 100) return;
    setTimeout(() => whenUsfReady(callback, (attempts || 0) + 1), 50);
  }

  function loadUsfBoot() {
    if (bootPromise) return bootPromise;

    bootPromise = new Promise((resolve) => {
      const src = window._usfTheme?.assetUrl;
      if (!src) {
        resolve();
        return;
      }

      const finish = () => whenUsfReady(resolve);

      if (window._usfBootLoaded) {
        finish();
        return;
      }

      window._usfBootLoaded = true;
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = finish;
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });

    return bootPromise;
  }

  function resolveSearchInput(el) {
    if (!el) return null;
    if (el.tagName === 'INPUT') return el;
    return el.querySelector('input[type="search"], .search__input');
  }

  function activateSearchInput(target) {
    const input = resolveSearchInput(target);
    if (!input) return;

    const savedValue = input.value;

    loadUsfBoot().then(() => {
      whenUsfReady(() => {
        const field = input.closest('.field') || input.parentNode;
        let activeInput = field?.querySelector('.search__input, input[type="search"]') || input;
        const parent = activeInput.parentNode;

        if (!parent?.classList?.contains('usf-sr-inputbox')) {
          window.usf.utils.installSearchInput(activeInput);
          activeInput = parent?.querySelector('.search__input, input[type="search"]') || activeInput;
          if (savedValue && activeInput.value !== savedValue) {
            activeInput.value = savedValue;
          }
        }

        if (activeInput.value && window.usf?.utils?.loadAndShowInstantSearch) {
          window.usf.utils.loadAndShowInstantSearch(activeInput);
        }
      });
    });
  }

  function loadUsf() {
    loadUsfBoot();
  }

  window._usfDeferredLoad = loadUsf;

  function shouldAutoLoad() {
    if (window._usfAutoLoad) return true;
    if (document.getElementById('usf_container')) return true;
    const path = window.location.pathname;
    return /\/collections\//.test(path) || /\/search/.test(path);
  }

  function bindSearchTriggers() {
    const searchSelectors = ['.search__input', 'form[action*="/search"] input[type="search"]'];

    searchSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((input) => {
        ['pointerdown', 'focus', 'input'].forEach((eventName) => {
          input.addEventListener(eventName, () => activateSearchInput(input), { passive: true });
        });
      });
    });

    const preloadSelectors = ['#mobile_search_icon', '.header__icon--search', 'a[href*="search"]'];

    preloadSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        ['click', 'pointerdown'].forEach((eventName) => {
          el.addEventListener(eventName, () => loadUsfBoot(), { passive: true });
        });
      });
    });
  }

  function boot() {
    if (shouldAutoLoad()) {
      loadUsfBoot();
      return;
    }
    bindSearchTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
    var searchIcon = document.querySelector('.header__icon[id="mobile_search_icon"]');
    if (searchIcon) {
        searchIcon.addEventListener('click', function (e) {
            var target = document.createElement('input');
            usf.utils.loadAndShowInstantSearch(target, true);
            usf.utils.stopEvent(e);
        })
    }
  }
})();
